import { gql } from '@apollo/client';

// Input Example
// {
//   "input":{
//     "name":"GraphQL HOYA test 2"
// }

export const CREATE_SCORM_COURSE = gql`
  mutation createScormCourse( $input: CreateScormCourseInput! ){
        result: createScormCourse(input: $input) {
          id
          name
          signedUrl
        }
    }
`;
 